import { IoVideocamOutline } from "react-icons/io5";
import { useInfoUser } from "../../../store/UserStore";
import { Button } from "antd";
import { FaRegStar, FaStar } from "react-icons/fa6";

const CallingFeedback = ()=>{
 const { user, languageMap } = useInfoUser();

    return <div className="h-[100%] text-[white] text-center flex flex-col justify-between py-[150px]">
        <div>
            <div className="text-[21px]">
             {languageMap?.["call.quality"] ?? "How do you think about call quality ?"}
        </div>
        <div className="flex gap-[10px] justify-center mt-[20px]">
            <Button
              type="default"
            //   shape="circle"
              className="border-black bg-[black] text-[#575757]"
              size="large"
              icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
            />
             <Button
              type="default"
            //   shape="circle"
              className="border-black bg-[black] text-[#575757]"
              size="large"
              icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
            />
             <Button
              type="default"
            //   shape="circle"
              className="border-black bg-[black] text-[#575757]"
              size="large"
              icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
            />
             <Button
              type="default"
            //   shape="circle"
              className="border-black bg-[black] text-[#575757]"
              size="large"
              icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
            />
             <Button
              type="default"
            //   shape="circle"
              className="border-black bg-[black] text-[#575757]"
              size="large"
              icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
            />
        </div>
        </div>
        <div>
            {/* <Button
              type="default"
              shape="circle"
              className="bg-[#37b361] text-[white]"
              size="large"
              icon={<IoVideocamOutline size={25} />}
            //   onClick={openCallWindow}
            /> */}
        </div>
    </div>
}

export {CallingFeedback}